'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import SiteError from '@/components/reference/SiteError'

/**
 * Error boundary for Hive page
 * Catches errors and displays a branded error page with recovery options
 */
export default function HiveError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error to Sentry
    Sentry.captureException(error)
    console.error('Hive page error:', error)
  }, [error])

  return (
    <SiteError
      error={error}
      reset={reset}
      title='Oops! Something went wrong'
      message={
        "We encountered an error while loading Hive. Don't worry, our team has been notified."
      }
      links={[
        { href: '/vector', label: 'Explore Vector' },
        { href: '/', label: 'Go home' },
      ]}
      help
    />
  )
}
